import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import { DEFAULT_AVATAR_URL } from "../../common/enum";
import {
  query,
  collection as firebaseCollection,
  where,
  getCountFromServer,
  onSnapshot,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector, useDispatch } from "react-redux";

const MessagesUsersTabs = ({ value, handleChange, user }) => {
  const {
    auth: { profile },
  } = useSelector((state) => state);

  const [allUsers, setAllUsers] = React.useState([]);

  const getAllUser = React.useCallback(async () => {
    if (user.length > 0) {
      const arr = [];
      for (let doc of user) {
        const qu = query(
          collectionGroup(db, "messages"),
          where("senderId", "==", doc?.userRegistrationId),
          where("recevierId", "==", profile?.userId),
          where("isRead", "==", false)
        );
        const snapshotUnSub = await getCountFromServer(qu);
        arr.push({
          ...doc,
          unreadMessageCount: snapshotUnSub.data().count,
        });
      }
      setAllUsers([...arr]);
    } else {
      setAllUsers([]);
    }
  }, [user]);

  React.useEffect(() => {
    if (user.length > 0) {
      getAllUser();
    }
  }, [user]);

const [profileImages, setProfileImages] = useState(new Map());
const dispatch = useDispatch();

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of allUsers) {
      const id = item?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
            newMap.set(item.userRegistrationId, imageUrl);
        }else{
            newMap.set(item.userRegistrationId, DEFAULT_AVATAR_URL);
        }
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [allUsers, dispatch]);



  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="icon label tabs example"
      orientation="vertical"
      sx={{ borderRight: 1, borderColor: "divider" }}
    >
      {allUsers !== undefined &&
        allUsers.length > 0 &&
        allUsers.map((item) => (
          <Tab
            icon={
              <Badge
                color="primary"
                badgeContent={
                  profile?.userId !== item.userRegistrationId
                    ? item.unreadMessageCount
                    : 0
                }
                max={99}
              >
                <Avatar
                  src={
                    item.profilePicture === "string" ||
                    item.profilePicture === null
                      ? DEFAULT_AVATAR_URL
                      : profileImages.get(item.userRegistrationId)
                  }
                  sx={{ backgroundColor: "green" }}
                />
              </Badge>
            }
            key={item.userRegistrationId}
          />
        ))}
    </Tabs>
  );
};

export default MessagesUsersTabs;
